import React, { useContext, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { AuthContextTwo } from "../../contexts/AuthProviderTwo";
import "./DashTutorMobile.css";

const DashboardTutorMobile = () => {
  const { userTwo, logOutTwo } = useContext(AuthContextTwo);

  const [activeLink, setActiveLink] = useState(null);

  const handleSetActiveLink = (link) => {
    setActiveLink(link);
    setIsSidebarOpen(false); // Close the sidebar after selecting a link
  };
  

  // State to manage sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [profileData, setProfileData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/user/${userTwo?.email}`
      );
      const data = await response.json();
      setProfileData(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderLocalUserUI = () => (
    <ul className="w-full h-screen bg-green-50">
      <div className="flex flex-col bg-green-700 px-4 py-8">
        <div className="">
          {profileData.map((data) => (
            <div
              className=" sm:flex sm:justify-center sm:items-center w-full rounded-t-lg "
              key={data.img}
            >
              {data.img ? (
                <img
                  id=""
                  className="w-20 h-20 rounded-lg"
                  src={data.img}
                  alt=""
                />
              ) : (
                <div className="flex items-center  justify-center ">
                  <img
                    id=""
                    className="rounded-full bg-white w-20"
                    src="https://i.ibb.co/BsSBQBp/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector.png"
                    alt=""
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="sm:mt-4">
          {profileData.map((data) => (
            <div className="lg:ml-4 flex justify-center items-center flex-col">
              <h1 className=" text-lg font-montserrat text-white py-1">
                Name: {data.name}
              </h1>
              <p className=" text-md font-montserrat text-white">
                Email: {userTwo.email}
              </p>
              <p className=" text-md font-montserrat text-white">
                Phone: {data.phone}
              </p>
              <h1 className=" text-md font-montserrat text-white">
                User Id: {data._id.slice(-6)}
              </h1>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col justify-between">
        <div className="px-4">
          <li className="my-4">
            <Link
              to="/dashboardTutorMobile/dash-tutor-mobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/dashboardTutorMobile"
                  ? "border-b border-green-900 "
                  : ""
              }`}
              onClick={() => handleSetActiveLink("/dashboardTutorMobile")}
            >
              Dashboard
            </Link>
          </li>
          <li className="my-4">
            <Link
              to="/dashboardTutorMobile/tutor-profile-mobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/dashboardProfileTutor"
                  ? "border-b border-green-900 "
                  : ""
              }`}
              onClick={() => handleSetActiveLink("/dashboardProfileTutor")}
            >
              Profile
            </Link>
          </li>
          <li className="my-4">
            <Link
              to="/dashboardTutorMobile/tutor-profile-job-board-mobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/JobBoardTutorMobile"
                  ? "border-b border-green-900 "
                  : ""
              }`}
              onClick={() => handleSetActiveLink("/JobBoardTutorMobile")}
            >
              Job Board
            </Link>
          </li>
          <li className="my-4">
            <Link
              to="/dashboardTutorMobile/tutor-payment-mobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/paymentMobile"
                  ? "border-b border-green-900 "
                  : ""
              }`}
              onClick={() => handleSetActiveLink("/paymentMobile")}
            >
              Payment
            </Link>
          </li>
          <li className="my-4">
            <Link
              to="/dashboardTutorMobile/tutor-settings-mobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/settingMobile"
                  ? "border-b border-green-900 "
                  : ""
              }`}
              onClick={() => handleSetActiveLink("/settingMobile")}
            >
              Settings
            </Link>
          </li>
        </div>
        <div className="border-t border-green-200 w-full px-4 mt-12">
          <li className="my-2">
            <Link
              to="/dashboardTutorMobile"
              className={`text-2xl font-signika text-green-900   ${
                activeLink === "/logout" ? "border-b border-green-900 " : ""
              }`}
              onClick={() => handleSetActiveLink("/logout")}
            >
              Logout
            </Link>
          </li>
        </div>
      </div>
    </ul>
  );

  return (
    <div>
      <div className="bg-green-700 w-full p-2">
        <div className="flex justify-between items-center">
          <button
            className="lg:text-white sm:mt-2 md:hidden lg:hidden"
            onClick={toggleSidebar}
          >
            <img
              className="w-12"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTMgNmExIDEgMCAwIDEgMS0xaDE2YTEgMSAwIDEgMSAwIDJINGExIDEgMCAwIDEtMS0xem0wIDZhMSAxIDAgMCAxIDEtMWgxMGExIDEgMCAxIDEgMCAySDRhMSAxIDAgMCAxLTEtMXptMCA2YTEgMSAwIDAgMSAxLTFoNWExIDEgMCAxIDEgMCAySDRhMSAxIDAgMCAxLTEtMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </button>
          <h1 className="text-2xl font-marcellus text-white text600">
            Tutor Tree
          </h1>
          <button
            className="lg:text-white sm:mt-2 md:hidden lg:hidden"
            onClick={toggleSidebar}
          ></button>
        </div>
        <div className={`sidebarMobile ${isSidebarOpen ? "openMobile" : ""}`}>
          {renderLocalUserUI()}
        </div>
        <div
          className={`overlayMobile ${isSidebarOpen ? "activeMobile" : ""}`}
          onClick={toggleSidebar}
        ></div>
      </div>
      <Outlet></Outlet>
    </div>
  );
};

export default DashboardTutorMobile;
